import { useEffect, useRef } from 'react';
/*
  Executes code on a given interval. The interval can be paused by setting the delay to `null`.

  useInterval(() => {
    console.log('hello world');
  }, 1000);
*/

export const useInterval = (callback: Function, delay?: number | null) => {
  const savedCallback = useRef<Function>(() => {});

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      const interval = setInterval(() => savedCallback.current(), delay || 0);
      return () => clearInterval(interval);
    }

    return undefined;
  }, [delay]);
};
